import apiClient from "../axios.config";

const expenseService = {
  posttPropertyExpense(payload) {
    return apiClient.post("/owner/properties/expenses", payload);
  },
  posttPropertyRentExpense(payload) {
    return apiClient.post("/owner/properties/owner-expense-report", payload);
  },
  getMonthlyExpenses(payload) {
    return apiClient.post("/owner/properties/monthly-expenses", payload);
  },
};

export default expenseService;
